<template>
  <div class="currentResult">
    <div class="currentResult_header">
      <div class="currentResult_header_left" @click="$router.push({ path: '/currentList' })">
        <i class="iconfont iconfanhui"></i>
        <p>返回</p>
      </div>
    </div>

    <div class="currentResult_main">
      <div class="currentResult_main_box">
        <p class="currentResult_main_title">测试结果</p>
        <div class="currentResult_main_result">{{ result }}</div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'currentResult',
  data () {
    return {
      cid: this.$route.params.cid,
      result: ''
    }
  },
  methods: {
    getCurrentResultList () {
      this.util.get(this.api.current_result_list + '?cid=' + this.cid, '', (success) => {
        this.result = success.result
      })
    }
  },
  mounted () {
    this.getCurrentResultList()
  }
}
</script>

<style scoped lang="scss">
  @import "../../assets/scss/functions";

  .currentResult {
    padding: pxToRem(10px);

    .currentResult_header {
      margin-bottom: pxToRem(40px);

      .currentResult_header_left {
        display: flex;
        padding-left: pxToRem(10px);
        width: pxToRem(120px);
        height: pxToRem(88px);
        line-height: pxToRem(88px);
      }
    }

    .currentResult_main {
      padding: 0 pxToRem(30px);

      .currentResult_main_box {
        padding: pxToRem(100px) pxToRem(30px);
        padding-bottom: pxToRem(200px);
        background-color: #fff;
        border-radius: pxToRem(30px);

        .currentResult_main_title {
          font-size: pxToRem(35px);
          color: #28282a;
          margin-bottom: pxToRem(40px);
          font-weight: 600;
        }

        .currentResult_main_result {
          padding: pxToRem(30px);
          border-radius: pxToRem(30px);
          background-image: linear-gradient(90deg,#1071f5,#3caffc);
          text-align: center;
          font-weight: 700;
          color: #fff;
          margin-bottom: pxToRem(50px);
        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/views/current/result.vue